import { useCallback } from 'react';

import { HiDotsVertical } from 'react-icons/hi';
import { useHistory } from 'react-router-dom';

import { Container, LineWrapper, Options, Wrapper } from './styles';

type Exercise = {
  id: number;
  name: string;
  muscle_segment: string;
};

type Props = {
  exercise: Exercise;
  isAdminExercise: boolean;
  select: (exercise: Exercise) => void;
  deleteModal: (value: boolean) => void;
};

export function Card({
  exercise,
  isAdminExercise,
  select,
  deleteModal,
}: Props) {
  const { push } = useHistory();

  const handleNavigateToEditExercise = useCallback(() => {
    push(`/professional/lab/ex-editor/${exercise.id}`, exercise);
  }, [push, exercise]);

  return (
    <Container>
      {!isAdminExercise && (
        <Options>
          <HiDotsVertical size={22} color="#000" />

          <div>
            <button onClick={handleNavigateToEditExercise} type="button">
              Editar
            </button>

            <div className="divider" />

            <button
              onClick={() => {
                select(exercise);
                deleteModal(true);
              }}
              type="button"
            >
              Excluir
            </button>
          </div>
        </Options>
      )}

      <Wrapper>
        <LineWrapper>
          <strong>Nome: </strong>&nbsp;
          <p>{exercise.name}</p>
        </LineWrapper>

        <LineWrapper>
          <strong>Segmento muscular:</strong>&nbsp;
          <p>{exercise.muscle_segment}</p>
        </LineWrapper>
      </Wrapper>
    </Container>
  );
}
